<template>
    <v-dialog
        :value="isOpen"
        fullscreen
        transition="slide-y-transition"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <span>Nowa reklamacja</span>
                <v-spacer />
                <v-btn
                    icon
                    @click="onClose"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <Complaint
                    v-if="isOpen"
                    :as-popup="true"
                    :stop-card="stopCard"
                    :order="order"
                    @close="onClose"
                />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Complaint from '@/views/Complaints/Complaints/Complaint'

export default {
    name: 'ComplaintsCreatedDialog',
    components: {
        Complaint
    },
    props: {
        isOpen: {
            type: Boolean
        },
        stopCard: {
            type: Object,
            default: null
        },
        order: {
            type: String,
            default: null
        }
    },
    methods: {
        onClose() {
            this.$emit('close')
        }
    }
}
</script>